import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import * as styles from './styles';

const SHOW_AFTER_SCROLL_PX = 480;

function BackToTop() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        function handleScroll() {
            setVisible(window.scrollY > SHOW_AFTER_SCROLL_PX);
        }
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    function handleClick() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (!visible) return null;

    return (
        <Box component="button" type="button" onClick={handleClick} aria-label="Back to top" sx={styles.button}>
            <ArrowUpwardIcon sx={{ fontSize: 20 }} />
        </Box>
    );
}

export default BackToTop;
